/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

import classNames from "clsx";

import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";

import { FiFilter } from "react-icons/fi";

import { useApi } from "@/hooks/useApi";
import { useThemeMode } from "@/../_metronic/partials";
import { transformData } from "@/utils/transformData";
import { paginatedAttendancesMap } from "@/utils/mappings/paginatedAttendances";

import { HopitalizationPermitsFiltersModal } from "@/components/HospitalizationPermits/HopitalizationPermitsFiltersModal";
import { HospitalizationPermitsTable } from "@/components/HospitalizationPermits/HospitalizationPermitsTable";
import { PaginationLinks } from "@/components/PaginationLinks";
import { SearchFormControl } from "@/components/FormControl/SearchFormControl";

import "./styles.scss";

type PaginatedAttendances = TransformedGenericPagination<Attendance>;

export function HospitalizationPermitsManagementPage() {
	const { api } = useApi();
	const { mode } = useThemeMode();

	const [showModalFilters, setShowModalFilters] = useState(false);
	const handleShowModalFilters = () => setShowModalFilters(true);
	const handleCloseModalFilters = () => setShowModalFilters(false);

	const [attendances, setAttendances] = useState<PaginatedAttendances>(
		{} as PaginatedAttendances
	);
	const [page, setPage] = useState(0);

	const [loading, setLoading] = useState(true);

	async function handleFetchHospitalizationPermits() {
		try {
			const { data } = await api.get("/hospitalization-permits", {
				params: {
					page: page + 1,
				},
			});

			const transformedAttendances = transformData<PaginatedAttendances>(
				data,
				paginatedAttendancesMap
			);

			setAttendances(transformedAttendances);
			setLoading(false);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		handleFetchHospitalizationPermits();
	}, [page]);

	const hasAttendances = attendances.results?.length > 0;

	return (
		<>
			<Row className="mb-4">
				<div className="d-flex justify-content-between container-filters">
					<div className="col-4 container-search">
						<SearchFormControl placeholder="Pesquisar paciente" />
					</div>

					<button
						className={classNames(
							"btn shadow text-gray-700 hover-elevate-up",
							mode === "dark" ? "dark-theme-button-light" : "theme-button-light"
						)}
						onClick={handleShowModalFilters}
					>
						<FiFilter /> Filtro
					</button>
				</div>
			</Row>

			<Row className="px-3">
				<HopitalizationPermitsFiltersModal
					show={showModalFilters}
					onHide={handleCloseModalFilters}
				/>

				<Card className="min-height-48rem">
					<Card.Body className="d-flex justify-content-center">
						<div className="w-100">
							{loading ? (
								<div className="h-100 d-flex justify-content-center align-items-center">
									<Spinner animation="border" variant="primary" />
								</div>
							) : hasAttendances ? (
								<div className="min-height-40rem w-100 mb-6">
									<div className="table-responsive">
										<HospitalizationPermitsTable
											attendances={attendances.results}
										/>
									</div>
								</div>
							) : null}

							{hasAttendances && (
								<PaginationLinks
									pageCount={attendances.meta?.lastPage}
									onPageChange={({ selected }) => {
										setLoading(true);
										setPage(selected);
									}}
								/>
							)}
						</div>
					</Card.Body>
				</Card>
			</Row>
		</>
	);
}
